import { Actions, Mutations } from "./global.types";
import { GlobalService } from "../../common/services/api.service";

export default {
  async [Actions.GET_USER_TASKS]({ commit }) {
    commit(Mutations.SHOW_SPINNER);
    const response = await GlobalService.getTasks();
    commit(Mutations.SET_USER_TASKS, response.data.data.tasks);
    commit(Mutations.HIDE_SPINNER);
  },
  async [Actions.GET_USER_PROFILE]({ commit }) {
    const response = await GlobalService.getUserProfile();
    commit(Mutations.SET_USER_PROFILE, response.data.data.user);
  },
  async [Actions.GET_SURVEY_PROFILE]({ commit }) {
    const response = await GlobalService.getSurveyProfile();
    commit(Mutations.SET_SURVEY_PROFILE, response.data.data);
  }
};
